<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
        d="M21.28,16l9.9-9.9a2.81,2.81,0,0,0,0-4L29.86.82a2.81,2.81,0,0,0-4,0L16,10.72,6.1.82a2.81,2.81,0,0,0-4,0L.82,2.14a2.81,2.81,0,0,0,0,4l9.9,9.9L.82,25.9a2.81,2.81,0,0,0,0,4l1.32,1.32a2.81,2.81,0,0,0,4,0l9.9-9.9,9.9,9.9a2.81,2.81,0,0,0,4,0l1.32-1.32a2.81,2.81,0,0,0,0-4Z" />
</svg>